import type { FC } from "react";
import styles from "./Separator.module.css";

interface SeparatorProps {
  orientation?: "horizontal" | "vertical";
  className?: string;
}

export const Separator: FC<SeparatorProps> = ({
  orientation = "horizontal",
  className,
}) => {
  return (
    <div
      className={`${styles.separator} ${styles[orientation]} ${className || ""}`}
      role="separator"
      aria-orientation={orientation}
    />
  );
};
